import date from './date'
import array from './array'
import color from './color'
import number from './number'
import string from './string'
import object from './object'


export {
  date,
  array,
  color,
  number,
  string,
  object,
}
